import { render, staticRenderFns } from "./EWLimitConfigLogForm.vue?vue&type=template&id=48c712bf&"
import script from "./EWLimitConfigLogForm.vue?vue&type=script&lang=js&"
export * from "./EWLimitConfigLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports